import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1100px;
  margin: 0rem auto;
  width: 70%;
`;
